var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ib-guided-tour", {
    attrs: {
      "tour-name": "businessPlanTour",
      steps: _vm.tourSteps,
      "show-intro-dialog": _vm.showIntroDialog,
      "intro-delay": 1000,
    },
    on: {
      "tour-start": function ($event) {
        return _vm.$emit("tour-start")
      },
      "tour-end": function ($event) {
        return _vm.$emit("tour-end")
      },
      "intro-skip": function ($event) {
        return _vm.$emit("intro-skip")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "intro-image",
        fn: function () {
          return [
            _c("img", {
              staticStyle: { width: "125px" },
              attrs: {
                src: require("@/assets/img/onboarding/idea.svg"),
                alt: "",
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "intro",
        fn: function () {
          return [
            _c(
              "h1",
              { staticClass: "text-center mb-2 font-outfit-semi-bold" },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("pages.businessPlan.tour.introTitle")) +
                    " "
                ),
              ]
            ),
            _c(
              "p",
              {
                staticClass: "text-center",
                staticStyle: { "font-size": "18px" },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("pages.businessPlan.tour.introText")) +
                    " "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }